<template>
  <div class="layer layer2">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.all_product_list }}</h2>
      <div class="flexBox">
        <div class="flexInner flexFrame">
          <div v-if="list" class="shopOptionList">
            <input type="text" v-model="searchItem" class="input searchInput" placeholder="pId or item name">
            <ul class="optionList clickable">
              <li
                v-for="(shopItem, index) in filteredList"
                :key="index"
                class="optionItem">
                <p v-if="shopItem.pId" class="pid">{{ shopItem.pId }}</p>
                <div class="checkbox">
                  <input
                    type="radio"
                    name="shopItem_list_all"
                    :id="`shopItem_${index}`"
                    :value="shopItem.shopItemId"
                    v-model="checked">
                  <label
                    :for="`shopItem_${index}`"
                    :class="{isInactive: !shopItem.isActive}">
                      <span v-if="!shopItem.isActive" class="activeStkr"></span>
                      <span v-if="shopItem.isOptItem" class="itemStkr">{{ locale.option_item }}</span>
                      {{ !pageId ? `(${shopItem.pageName})` : '' }}
                      {{ shopItem.title || shopItem.shopItemName[defaultLang] }}
                  </label>
                </div>
              </li>
              <li v-if="filteredList.length <= 0" class="optionItem">{{ locale.no_selectable_product }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" @click="apply">{{ locale.confirm }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import UTIL from '@/common/util'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'ItemListAll',
  props: [
    'locale',
    'checkedId',
    'ignorePosItem', // mustSyncPos인 샵은 직접 옵션을 구성할 때 pos아이템을 추가할수없음
    'isApply'
  ],
  components: {
    SetLanguageValue
  },
  computed: {
    pageId () {
      return this.$route.params.id
    },
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    filteredList () {
      const word = regExp.replaceAllEmpty(this.searchItem)
      const list = this.list
      return list.filter(x => {
        const shopPageName = regExp.replaceAllEmpty(x.pageName || '')
        const nameValues = Object.values(x.shopItemName).map(value => regExp.replaceAllEmpty(value))
        const pId = regExp.replaceAllEmpty(x.pId)
        return word.length > 0
          ? nameValues.find(name => regExp.replaceAllEmpty(name).includes(word)) || pId.includes(word) || shopPageName.includes(word)
          : true
      })
    }
  },
  async created () {
    this.checked = this.checkedId || ''
    this.getItemListAll()
  },
  data () {
    return {
      checked: '',
      list: [],
      searchItem: ''
    }
  },
  methods: {
    getShopPageName (pageId) {
      const shopPageList = this.$store.getters['shop/getShopPageList'] || []
      return shopPageList?.find(page => page.pageId === pageId)?.pageName || pageId
    },
    async getAvailableShopOptItems () {
      this.$store.commit('onLoading', true)
      const getList = await this.$store.dispatch('shop/getAvailableShopOptItems')
      const list = getList && getList.message && getList.message.shopItems
      if (list) {
        this.list = list.map(item => {
          return {
            ...item,
            ...item.pageId && {
              pageName: this.getShopPageName(item.pageId)
            }
          }
        })
      }
      this.$store.commit('onLoading', false)
    },
    async getItemListAll () {
      this.$store.commit('onLoading', true)
      // 페이지 구분 없이 모든 상품리스트를 호출할 경우 어느페이지의 상품인지 구분해야하므로 모든페이지 리스트를 호출해서 페이지명을 매핑해야함
      await this.$store.dispatch('shop/getShopPageList')
      const getList = this.$route.name === 'shopOption' || this.isApply
        ? await this.$store.dispatch('shop/getAvailableShopOptItems')
        : await this.$store.dispatch('shop/getAllShopItems', this.pageId)
      const list = getList && getList.message && getList.message.shopItems
      if (list) {
        this.list = list.map(item => {
          return {
            ...item,
            ...item.pageId && {
              pageName: this.getShopPageName(item.pageId)
            }
          }
        })
      }
      this.$store.commit('onLoading', false)
    },
    close () {
      this.$emit('close')
    },
    apply () {
      const item = this.list.find(x => x.shopItemId === this.checked)
      if (item) {
        this.$emit('apply', item)
        this.close()
      } else {
        alert(this.locale.shop_no_items)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 460px;
  }
}
.shopOptionList .optionItem {
  position: relative;
  padding-right: 12px;
  white-space: normal;
  word-break: break-all;
  word-wrap: initial;
  .checkbox label {
    display: flex;
    align-items: center;
  }
}
.pid {
  position: absolute;
  top: 2px;
  left: 35px;
  opacity: 0.4;
  font-size: 10px;
}
.isInactive {
  color: $color-lgrey;
}
.activeStkr {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  background: url('~@/assets/img/hide.png') 50% 50% / contain no-repeat;
  opacity: 0.25;
}
.itemStkr {
  margin-right: 4px;
  padding: 0 4px;
  font-size: 10px;
  color: $color-white;
  border-radius: 4px;
  background-color: $color-lgrey;
}
</style>